export interface IDocMeta {
  slug: string;
  title: string;
  description: string;
  order: number;
}

export const kDocsMeta: IDocMeta[] = [
  {
    slug: "api-keys",
    title: "API Keys",
    description:
      "Create and authenticate with API keys so your apps can call ChoreBuddy.",
    order: 1,
  },
  {
    slug: "create-chores",
    title: "Create Chores via API",
    description:
      "Create chores from your product to track requests and feedback from clients and users.",
    order: 2,
  },
];

export function getDocsNav(): IDocMeta[] {
  return [...kDocsMeta].sort((a, b) => a.order - b.order);
}

export function getDocMeta(slug: string): IDocMeta | null {
  return kDocsMeta.find((doc) => doc.slug === slug) ?? null;
}

export function getFirstDocSlug(): string {
  return getDocsNav()[0].slug;
}

export function getAllDocSlugs(): string[] {
  return getDocsNav().map((doc) => doc.slug);
}
